// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.part-list {
    background: rgba(24,24,154,0);
    margin-top: 5px;
    padding-top: 5px;
}

.part-list h4 {
    margin-left: 10px;
}

.part-list ul {
    list-style-type: none;
    padding: 0;
}

.part-list li {
    background: rgba(24,24,154,0);
    padding: 10px;
    cursor: pointer;
    border: 0;
    margin: 0;
    border-radius: 0;
}

.part-list a {
    margin-left: 5px;
}

.part-list li:hover {
    background-color: #d9d9d9;
}

.part-list li.selected {
    background-color: #d0d0d0;
    border-bottom: 1px solid #bbb;
}

.part-list h4 {
    margin-top: 10px;
    color: #333;
}`, "",{"version":3,"sources":["webpack://./src/PartList.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,SAAS;IACT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf","sourcesContent":[".part-list {\n    background: rgba(24,24,154,0);\n    margin-top: 5px;\n    padding-top: 5px;\n}\n\n.part-list h4 {\n    margin-left: 10px;\n}\n\n.part-list ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.part-list li {\n    background: rgba(24,24,154,0);\n    padding: 10px;\n    cursor: pointer;\n    border: 0;\n    margin: 0;\n    border-radius: 0;\n}\n\n.part-list a {\n    margin-left: 5px;\n}\n\n.part-list li:hover {\n    background-color: #d9d9d9;\n}\n\n.part-list li.selected {\n    background-color: #d0d0d0;\n    border-bottom: 1px solid #bbb;\n}\n\n.part-list h4 {\n    margin-top: 10px;\n    color: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
